import { Entity, EntityMap, FeedType, HidableFeedType, PinnableFeedType } from '../types';

export enum RequestStatusType {
  AcknowledgeStreamEventPolicyRequest = 'AcknowledgeStreamEventPolicyRequest',
  AddFavoriteGroupRequest = 'AddFavoriteGroupRequest',
  AddThreadTopicRequest = 'AddThreadTopicRequest',
  AddToDirectAudienceRequest = 'AddToDirectAudienceRequest',
  AllNetworkGroupsLoadMoreRequest = 'AllNetworkGroupsLoadMoreRequest',
  AppViewPropertiesRequest = 'AppViewPropertiesRequest',
  AppViewPropertiesSetRequest = 'AppViewPropertiesSetRequest',
  CampaignPinnedResourcesPinLink = 'CampaignPinnedResourcesPinLink',
  CampaignEditRequest = 'CampaignEditRequest',
  CampaignPublishRequest = 'CampaignPublishRequest',
  CampaignDeleteRequest = 'CampaignDeleteRequest',
  CampaignFollow = 'CampaignFollow',
  CampaignsListMoreRequest = 'CampaignsListMoreRequest',
  CampaignUnfollow = 'CampaignUnfollow',
  CampaignGoalTracker = 'CampaignGoalTracker',
  CampaignSash = 'CampaignSash',
  CampaignGoalTrackerCreateRequest = 'CampaignGoalTrackerCreateRequest',
  CampaignGoalTrackerEditRequest = 'CampaignGoalTrackerEditRequest',
  CampaignSashRequest = 'CampaignSashRequest',
  CancelEventRequest = 'CancelEventRequest',
  CoverImageDeleteRequest = 'CoverImageDeleteRequest',
  CoverImageUploadRequest = 'CoverImageUploadRequest',
  CreateAudienceFromDirectMembers = 'CreateAudienceFromDirectMembers',
  CreateAudienceFromOfficeGroupRequest = 'CreateAudienceFromOfficeGroupRequest',
  CreateCalendarInviteForTeamsMeetingRequest = 'CreateCalendarInviteForTeamsMeetingRequest',
  CreateGroupCalendarInviteForBroadcastRequest = 'CreateGroupCalendarInviteForBroadcastRequest',
  CreateTeamsMeetingRequest = 'CreateTeamsMeetingRequest',
  DelegationRemoveRequest = 'DelegationRemoveRequest',
  DelegationAddRequest = 'DelegationAddRequest',
  DelegationEditRequest = 'DelegationEditRequest',
  DeleteFileRequest = 'DeleteFileRequest',
  DeleteMessageRequest = 'DeleteMessageRequest',
  DeleteTeamsMeetingRequest = 'DeleteTeamsMeetingRequest',
  DeleteThreadRequest = 'DeleteThreadRequest',
  DesignateLeaderRequest = 'DesignateLeaderRequest',
  DesignateLeadersFromOfficeGroupAsyncActionRequest = 'DesignateLeadersFromOfficeGroupAsyncActionRequest',
  DownloadIcsRequest = 'DownloadIcsRequest',
  EditEventRequest = 'EditEventRequest',
  EditNetworkQuestionInfoPanel = 'EditNetworkQuestionInfoPanel',
  EditNetworkQuestionSettings = 'EditNetworkQuestionSettings',
  EditRestrictedPostingRequest = 'EditRestrictedPostingRequest',
  EditTeamsMeetingRequest = 'EditTeamsMeetingRequest',
  EditNetworkUsagePolicyRequest = 'EditNetworkUsagePolicyRequest',
  EditTenantConfigurationSettingsRequest = 'EditTenantConfigurationSettingsRequest',
  EditUserAchievementAdminSettingsRequest = 'EditUserAchievementAdminSettingsRequest',
  EditUserAchievementUserSettingsRequest = 'EditUserAchievementUserSettingsRequest',
  EventLoadByBroadcastIdRequest = 'EventLoadByBroadcastIdRequest',
  FeatureNotImplemented = 'FeatureNotImplemented',
  FeedLoadNewerThreadsRequest = 'FeedLoadNewerThreadsRequest',
  FeedLoadOlderThreadsRequest = 'FeedLoadOlderThreadsRequest',
  GroupAddUserByEmailRequest = 'GroupAddUserByEmailRequest',
  GroupAddUserRequest = 'GroupAddUserRequest',
  GroupAvatarUploadRequest = 'GroupAvatarUploadRequest',
  GroupDeletionRequest = 'GroupDeletionRequest',
  GroupDiscoverySettingsLoadRequest = 'GroupDiscoverySettingsLoadRequest',
  GroupEditRequest = 'GroupEditRequest',
  GroupEventsSidebarLoadRequest = 'GroupEventsSidebarLoadRequest',
  GroupFeedUnreadCountRequest = 'GroupFeedUnreadCountRequest',
  GroupHideForNetworkInDiscoveryRequest = 'GroupHideForNetworkInDiscoveryRequest',
  GroupHideForViewerInDiscoveryRequest = 'GroupHideForViewerInDiscoveryRequest',
  GroupMembersBulkUploadRequest = 'GroupMembersBulkUploadRequest',
  GroupMemberPanelPaginationsRequest = 'GroupMemberPanelPaginationsRequest',
  GroupUnhideForNetworkInDiscoveryRequest = 'GroupUnhideForNetworkInDiscoveryRequest',
  GroupUnhideForViewerInDiscoveryRequest = 'GroupUnhideForViewerInDiscoveryRequest',
  GroupPinnedResourcesPinLink = 'GroupPinnedResourcesPinLink',
  GroupResolveMembershipRequest = 'GroupResolveMembershipRequest',
  GroupMakeAdminRequest = 'GroupMakeAdminRequest',
  GroupRevokeAdminRequest = 'GroupRevokeAdminRequest',
  GroupRemoveUserRequest = 'GroupRemoveUserRequest',
  InboxUnreadCountRequest = 'InboxUnreadCountRequest',
  LiveEventsLoadByNetworkRequest = 'LiveEventsLoadByNetworkRequest',
  MarkAllNotificationsAsSeenRequest = 'MarkAllNotificationsAsSeenRequest',
  MarkAllGroupThreadsAsSeenRequest = 'MarkAllGroupThreadsAsSeenRequest',
  MarkUserDefaultAudienceRequest = 'MarkUserDefaultAudienceRequest',
  MessageUpvotesLoadMoreRequest = 'MessageUpvotesLoadMoreRequest',
  ModerateThreadRequest = 'ModerateThreadRequest',
  MyGroupsLoadMoreRequest = 'MyGroupsLoadMoreRequest',
  NotificationLoadMoreRequest = 'NotificationLoadMoreRequest',
  NotificationUnseenCountLoadRequest = 'NotificationUnseenCountLoadRequest',
  OfficeTopicLoadAuthorizedRequest = 'OfficeTopicLoadAuthorizedRequest',
  OfficialGroupsLoadMoreRequest = 'OfficialGroupsLoadMoreRequest',
  PinnedResourcesPinLink = 'PinnedResourcesPinLink',
  PollLoadRequest = 'PollLoadRequest',
  PromoteThreadRequest = 'PromoteThreadRequest',
  PublishMessageRequest = 'PublishMessageRequest',
  ReactionAccentColorUpdateRequest = 'ReactionAccentColorUpdateRequest',
  RemoveCuratedTopicRequest = 'RemoveCuratedTopicRequest',
  RemoveFromDirectAudienceRequest = 'RemoveFromDirectAudienceRequest',
  RemoveLeaderAudienceRequest = 'RemoveLeaderAudienceRequest',
  RemoveThreadTopicRequest = 'RemoveThreadTopicRequest',
  RemoveTopicRequest = 'RemoveTopicRequest',
  ReportMessageRequest = 'ReportMessageRequest',
  ResolveCampaignWeblink = 'ResolveCampaignWeblink',
  RevokeLeaderRequest = 'RevokeLeaderRequest',
  SearchLoadMoreRequest = 'SearchLoadMoreRequest',
  SecondLevelRepliesLoadNextRequest = 'SecondLevelRepliesLoadNextRequest',
  SecondLevelRepliesLoadPreviousRequest = 'SecondLevelRepliesLoadPreviousRequest',
  SecondLevelRepliesLoadLastRequest = 'SecondLevelRepliesLoadLastRequest',
  SharepointVideoLinkLoadRequest = 'SharepointVideoLinkLoadRequest',
  SuggestedTopicsLoadMoreRequest = 'SuggestedTopicsLoadMoreRequest',
  TeamsMeetingLoadRequest = 'TeamsMeetingFeedLoadRequest',
  TeamsMeetingsByOrganizerLoadRequest = 'TeamsMeetingsByOrganizerLoadRequest',
  ThreadBookmarkRequest = 'ThreadBookmarkRequest',
  ThreadCloseRequest = 'ThreadCloseRequest',
  ThreadHideFromCampaignFeedRequest = 'ThreadHideFromCampaignFeedRequest',
  ThreadLoadNewerRepliesRequest = 'ThreadLoadNewerRepliesRequest',
  ThreadListLoadRequest = 'ThreadListLoadRequest',
  ThreadMarkAsQuestionRequest = 'ThreadMarkAsQuestionRequest',
  ThreadMoveRequest = 'ThreadMoveRequest',
  ThreadPinToCampaignFeedRequest = 'ThreadPinToCampaignFeedRequest',
  ThreadPinToEventFeedRequest = 'ThreadPinToEventFeedRequest',
  ThreadPinToGroupFeedRequest = 'ThreadPinToGroupFeedRequest',
  ThreadPinToTeamsMeetingFeedRequest = 'ThreadPinToTeamsMeetingFeedRequest',
  ThreadPinToUserStorylineFeedRequest = 'ThreadPinToTeamsMeetingFeedRequest',
  ThreadRemoveParticipantsRequest = 'ThreadRemoveParticipantsRequest',
  ThreadReopenRequest = 'ThreadReopenRequest',
  ThreadsAppliedTopicNamesRequest = 'ThreadsAppliedTopicNamesRequest',
  ThreadShareLoadRequest = 'ThreadShareLoadRequest',
  ThreadUnbookmarkRequest = 'ThreadUnbookmarkRequest',
  ThreadUnmarkAsQuestionRequest = 'ThreadUnmarkAsQuestionRequest',
  ThreadUnpinFromCampaignFeedRequest = 'ThreadUnpinFromCampaignFeedRequest',
  ThreadUnpinFromEventFeedRequest = 'ThreadUnpinFromEventFeedRequest',
  ThreadUnpinFromGroupFeedRequest = 'ThreadUnpinFromGroupFeedRequest',
  ThreadUnpinFromTeamsMeetingFeedRequest = 'ThreadUnpinFromTeamsMeetingFeedRequest',
  ThreadUnpinFromUserStorylineFeedRequest = 'ThreadUnpinFromUserStorylineFeedRequest',
  TopicCreateRequest = 'TopicCreateRequest',
  TopicCurateRequest = 'TopicCurateRequest',
  TopicUncurateRequest = 'TopicUncurateRequest',
  TopicFollowersPaginationRequest = 'TopicFollowersPaginationRequest',
  TopLevelRepliesLoadInitialRepliesRequest = 'TopLevelRepliesLoadInitialRepliesRequest',
  TopLevelRepliesLoadLastRequest = 'TopLevelRepliesLoadLastRequest',
  TopLevelRepliesLoadNextRequest = 'TopLevelRepliesLoadNextRequest',
  TopLevelRepliesLoadPreviousRequest = 'TopLevelRepliesLoadPreviousRequest',
  TopicEditRequest = 'TopicEditRequest',
  TopicSidebarLoadRequest = 'TopicSidebarLoadRequest',
  TopicsCuratedLoadRequest = 'TopicsCuratedLoadRequest',
  TopicsCuratedLoadMoreRequest = 'TopicsCuratedLoadMoreRequest',
  TopicsFollowedLoadMoreRequest = 'TopicsFollowedLoadMoreRequest',
  TrendingTopicsLoadMoreRequest = 'TrendingTopicsLoadMoreRequest',
  WebLinkResolveRequest = 'WebLinkResolveRequest',
  UnpromoteThreadRequest = 'UnpromoteThreadRequest',
  UnseenThreadsLoadRequest = 'UnseenThreadsLoadRequest',
  UpdateHasNetworkWideAudienceRequest = 'UpdateHasNetworkWideAudienceRequest',
  UpdateHasMultiTenantWideAudienceRequest = 'UpdateHasMultiTenantWideAudienceRequest',
  UserConnectedLeadersListLoadMoreRequest = 'UserConnectedLeadersListLoadMoreRequest',
  UserFollowedLeadersListLoadMoreRequest = 'UserFollowedLeadersListLoadMoreRequest',
  UserNetworkLeadersListMoreRequest = 'UserNetworkLeadersListMoreRequest',
  UserDirectAudienceLoadMoreRequest = 'UserDirectAudienceLoadMoreRequest',
  UpdateUserAdminRolesRequest = 'UpdateUserAdminRolesRequest',
  UpdateStorylineDefaultNotificationDeliverySettingsRequest = 'UpdateStorylineDefaultNotificationDeliverySettingsRequest',
  UpdateStorylinePerUserControlSettingsRequest = 'UpdateStorylinePerUserControlSettingsRequest',
  UpdateStorylineMTOAdminSettingsRequest = 'UpdateStorylineMTOAdminSettingsRequest',
  UploadTenantLogoRequest = 'UploadTenantLogoRequest',
}

export type HideRequestStatusType = RequestStatusType.ThreadHideFromCampaignFeedRequest;

export type PinRequestStatusType =
  | RequestStatusType.ThreadPinToCampaignFeedRequest
  | RequestStatusType.ThreadPinToEventFeedRequest
  | RequestStatusType.ThreadPinToGroupFeedRequest
  | RequestStatusType.ThreadPinToTeamsMeetingFeedRequest
  | RequestStatusType.ThreadPinToUserStorylineFeedRequest;

export type UnpinRequestStatusType =
  | RequestStatusType.ThreadUnpinFromCampaignFeedRequest
  | RequestStatusType.ThreadUnpinFromEventFeedRequest
  | RequestStatusType.ThreadUnpinFromGroupFeedRequest
  | RequestStatusType.ThreadUnpinFromTeamsMeetingFeedRequest
  | RequestStatusType.ThreadUnpinFromUserStorylineFeedRequest;

export const acknowledgeStreamEventPolicyRequestId = 'streamPolicyAcknowledged';
export const liveEventsLoadByNetworkRequestId = 'liveEventsLoadByNetwork';
export const notificationUnseenCountRequestId = 'notificationUnseenCount';
export const inboxUnreadCountRequestId = 'inboxUnreadCountRequestId';
export const addFavoriteGroupRequestId = 'addFavoriteRejected';
export const updateReactionAccentColorRequestId = 'updateReactionAccentColor';
export const removeUserDelegateRequestId = 'removeUserDelegateRequestId';
export const threadListLoadRequestId = 'threadListLoadRequestId';
export const editTenantConfigurationSettingsRequestId = 'editTenantConfigurationSettingsRequestId';
export const editNetworkUsagePolicyRequestId = 'editNetworkUsagePolicyRequestId';
export const addUserDelegateRequestId = 'addUserDelegateRequestId';
export const editUserDelegateRequestId = 'editUserDelegateRequestId';
export const editNetworkQuestionInfoPanelRequestId = 'editNetworkQuestionInfoPanelRequestId';
export const editNetworkQuestionsSettingsRequestId = 'editNetworkQuestionsSettingsRequestId';
export const updateStorylineDefaultNotificationDeliverySettingsRequestId =
  'updateStorylineDefaultNotificationDeliverySettingsRequestId';
export const updateStorylinePerUserControlSettingsRequestId = 'updateStorylinePerUserControlSettingsRequestId';
export const updateStorylineMtoAdminSettingsRequestId = 'updateStorylineMtoAdminSettingsRequestId';
export const uploadTenantLogoRequestId = 'uploadTenantLogoRequestId';
export const suggestedTopicsLoadMoreRequestId = 'suggestedTopicsLoadMoreRequestId';
export const officialGroupsLoadMoreRequestId = 'officialGroupsLoadMoreRequestId';
export const updateHasMultiTenantWideAudienceRequestId = 'updateHasMultiTenantWideAudienceRequestId';

export interface RequestStatus extends Entity {
  readonly fulfilledTime: number;
}

export type RequestStatuses = EntityMap<RequestStatus>;

const hideRequestTypeMap: Record<HidableFeedType, HideRequestStatusType> = {
  [FeedType.Campaign]: RequestStatusType.ThreadHideFromCampaignFeedRequest,
};

const pinRequestTypeMap: Record<PinnableFeedType, PinRequestStatusType> = {
  [FeedType.LiveEvent]: RequestStatusType.ThreadPinToEventFeedRequest,
  [FeedType.Group]: RequestStatusType.ThreadPinToGroupFeedRequest,
  [FeedType.TeamsMeeting]: RequestStatusType.ThreadPinToTeamsMeetingFeedRequest,
  [FeedType.UserWall]: RequestStatusType.ThreadPinToUserStorylineFeedRequest,
  [FeedType.Campaign]: RequestStatusType.ThreadPinToCampaignFeedRequest,
};

const unpinRequestTypeMap: Record<PinnableFeedType, UnpinRequestStatusType> = {
  [FeedType.LiveEvent]: RequestStatusType.ThreadUnpinFromEventFeedRequest,
  [FeedType.Group]: RequestStatusType.ThreadUnpinFromGroupFeedRequest,
  [FeedType.TeamsMeeting]: RequestStatusType.ThreadUnpinFromTeamsMeetingFeedRequest,
  [FeedType.UserWall]: RequestStatusType.ThreadUnpinFromUserStorylineFeedRequest,
  [FeedType.Campaign]: RequestStatusType.ThreadUnpinFromCampaignFeedRequest,
};

type GetPinRequestStatusType = (targetFeedType?: PinnableFeedType) => PinRequestStatusType | undefined;
export const getPinRequestStatusType: GetPinRequestStatusType = (targetFeedType) =>
  targetFeedType ? pinRequestTypeMap[targetFeedType] : undefined;

type GetHideRequestStatusType = (targetFeedType?: HidableFeedType) => HideRequestStatusType | undefined;
export const getHideRequestStatusType: GetHideRequestStatusType = (targetFeedType) =>
  targetFeedType ? hideRequestTypeMap[targetFeedType] : undefined;

type GetUnpinRequestStatusType = (targetFeedType?: PinnableFeedType) => UnpinRequestStatusType | undefined;
export const getUnpinRequestStatusType: GetUnpinRequestStatusType = (targetFeedType) =>
  targetFeedType ? unpinRequestTypeMap[targetFeedType] : undefined;
